"use client";

import { useRouter } from "next/navigation";
import { FC, PropsWithChildren, Suspense } from "react";

import { AuthHeader } from "@/features/auth";
import { Footer, MediaQuery } from "@/shared/components";

import styles from "./layout.module.scss";

const ResetPasswordLayout: FC<PropsWithChildren> = ({ children }) => {
  const { replace } = useRouter();

  return (
    <Suspense fallback={"Loading..."}>
      <div className={styles.resetPasswordLayout}>
        <AuthHeader onClickBack={() => replace("/auth/login")} />
        {children}
        <MediaQuery.Laptop>
          <Footer fixedAtBottom transparent />
        </MediaQuery.Laptop>
      </div>
    </Suspense>
  );
};

export default ResetPasswordLayout;
